module.exports = __webpack_public_path__ + "static/media/pdf_1024.63b05129.png";